const format = [
  {
    value: 'verreImage',
    name: 'Prestashop 1.5',
    id: 1
  }
];

export default format;
